import { apiRequest, ApiResponse } from '../request'

export interface PushSubscription {
    id: string
    companyId: number
    oneSignalId: string
    platform: 'WEB' | 'ANDROID' | 'IOS'
    browser?: string | null
    isActive: boolean
    lastSeenAt?: Date | null
    createdAt: Date
    updatedAt: Date
}

export interface CreatePushSubscriptionDto {
    oneSignalId: string
    platform: 'WEB' | 'ANDROID' | 'IOS'
    browser?: string
    companyId?: number
}

export async function createPushSubscription(
    data: CreatePushSubscriptionDto
): Promise<ApiResponse<PushSubscription>> {
    return apiRequest<PushSubscription>('push-subscriptions', { data }, 'post')
}

export async function getPushSubscriptions(): Promise<
    ApiResponse<PushSubscription[]>
> {
    return apiRequest<PushSubscription[]>('push-subscriptions', {}, 'get')
}

export async function getPushSubscription(
    oneSignalId: string
): Promise<ApiResponse<PushSubscription>> {
    return apiRequest<PushSubscription>(
        `push-subscriptions/${oneSignalId}`,
        {},
        'get'
    )
}

export async function deactivatePushSubscription(
    oneSignalId: string
): Promise<ApiResponse<PushSubscription>> {
    return apiRequest<PushSubscription>(
        `push-subscriptions/${oneSignalId}/deactivate`,
        {},
        'patch'
    )
}

export async function deletePushSubscription(
    oneSignalId: string
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`push-subscriptions/${oneSignalId}`, {}, 'delete')
}

export async function pingPushSubscription(
    oneSignalId: string
): Promise<ApiResponse<void>> {
    return apiRequest<void>(
        `push-subscriptions/${oneSignalId}/ping`,
        {},
        'post'
    )
}
